import { defineStore } from 'pinia'
import { computed,ref } from 'vue'

/**
 * Aktuell ist dieser Store nur ein 1:1 Replacement für das alte Package vue-progress-bar,
 * aber er könnte erweitert werden um Ladebalken etc. allgemein zu vereinheitlichen (z.B. die LoadingItems vom FormStore)
 */

export const useProgressStore = defineStore('progress', () => {
  // State
  const loading = ref(false)

  // Actions
  function start() {
    loading.value = true
  }

  function finish() {
    loading.value = false
  }

  const loadingMinor = ref(false)
  const startMinor = () => loadingMinor.value = true
  const finishMinor = () => loadingMinor.value = false

  // Getter
  const isLoading = computed(() => loading.value || loadingMinor.value)
  const isLoadingMajor = computed(() => loading.value)
  const isLoadingMinor = computed(() => loadingMinor.value)

  return {
    loading, start, finish,
    loadingMinor, startMinor, finishMinor,
    isLoading, isLoadingMajor, isLoadingMinor
  }
})